import { connect } from 'react-redux';
import FrameworkUtils from 'utils/framework';
import ProductActions from 'actions/ProductActions';
import RwdBasketActions from 'actions/RwdBasketActions/RwdBasketActions';
import skuUtil from 'utils/Sku';
import sysUtils from 'utils/ShopYourStore';
import { QUERY_PARAMS } from 'constants/Shared';
import Empty from 'constants/empty';

const { wrapHOC } = FrameworkUtils;
const { fireProductViewableImpressionTracking } = ProductActions;
import { createStructuredSelector, createSelector } from 'reselect';
const { openRewardsBazaarModal } = RwdBasketActions;
import LanguageLocaleUtils from 'utils/LanguageLocale';
import itemLevelBasketErrors from 'selectors/basket/itemLevelBasketErrors';
import { isShopYourStorePreselectFulfillmentEnabledSelector } from 'viewModel/selectors/shopYourStore/isShopYourStorePreselectFulfillmentEnabledSelector';
const { getTextFromResource, getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('components/Product/ProductCard/locales', 'ProductCard');

const localization = createStructuredSelector({
    free: getTextFromResource(getText, 'free'),
    value: getTextFromResource(getText, 'value'),
    onlyAFewLeft: getTextFromResource(getText, 'onlyAFewLeft'),
    size: getTextFromResource(getText, 'size'),
    color: getTextFromResource(getText, 'color'),
    type: getTextFromResource(getText, 'type'),
    scent: getTextFromResource(getText, 'scent'),
    edit: getTextFromResource(getText, 'edit')
});

const fields = createSelector(
    (_state, ownProps) => ownProps.sku || {},
    (_state, ownProps) => ownProps.showVariationTypeAndValue || false,
    (_state, ownProps) => ownProps.showEditProductLink || false,
    (_state, ownProps) => ownProps.isCarousel || false,
    localization,
    itemLevelBasketErrors,
    isShopYourStorePreselectFulfillmentEnabledSelector,
    (sku, showVariationTypeAndValue, showEditProductLink, isCarousel, textResources, basketErrors, isShopYourStorePreselectFulfillmentEnabled) => {
        const variationType = sku.variationType
            ? skuUtil.isFragrance(sku) || skuUtil.hasSizeAndConcentration(sku)
                ? textResources.size || Empty.String
                : textResources[sku.variationType.toLowerCase()] || Empty.String
            : Empty.String;

        const variationString = sku.variationType && sku.variationValue ? `${variationType}: ${sku.variationValue}` : Empty.String;
        const displayEditLink = showEditProductLink && sku.variationType && sku.variationType.toLowerCase() !== 'none';
        const customQueryParams = [];
        let initialDeliveryOption = null;

        if (isCarousel && isShopYourStorePreselectFulfillmentEnabled) {
            initialDeliveryOption = sysUtils.getInitialDeliveryOption(isShopYourStorePreselectFulfillmentEnabled);

            if (initialDeliveryOption) {
                customQueryParams.push(`${QUERY_PARAMS.DELIVERY_OPTION}=${initialDeliveryOption.toLowerCase()}`);
            }
        }

        return {
            localization: textResources,
            itemLevelBasketErrors: basketErrors,
            variationString: showVariationTypeAndValue ? variationString : Empty.String,
            initialDeliveryOption,
            customQueryParams,
            displayEditLink
        };
    }
);

const functions = {
    fireProductViewableImpressionTracking,
    openRewardsBazaarModal
};

const withProductCardProps = wrapHOC(connect(fields, functions));

export {
    functions, withProductCardProps
};
